angular.module('aprima-legacy-common').factory('MessageTransitionToHelper',
    ['MessageTypes', '_', 'apFilterFeatureFilter', function (MessageTypes, _, apFilterFeature) {
        'use strict';

        var routes = {};
        routes[MessageTypes.PhoneMessageGuid] = {
            route: 'phonemessage'
        };
        routes[MessageTypes.TaskMessageGuid] = {
            route: 'taskmessage'
        };
        routes[MessageTypes.LabMessageGuid] = {
            route: 'labmessage'
        };
        routes[MessageTypes.PortalAppointmentQuestionMessageGuid] = {
            route: 'portalmessage'
        };
        routes[MessageTypes.PortalBillingQuestionMessageGuid] = {
            route: 'portalmessage'
        };
        routes[MessageTypes.PortalDemographicsQuestionMessageGuid] = {
            route: 'portalmessage'
        };
        routes[MessageTypes.PortalGeneralQuestionMessageGuid] = {
            route: 'portalmessage'
        };
        routes[MessageTypes.PortalRxQuestionMessageGuid] = {
            route: 'portalmessage'
        };
        routes[MessageTypes.AttachmentApprovalGuid] = {
            route: 'aamessage'
        };
        routes[MessageTypes.ServiceOrderApprovalMessageGuid] = {
            route: 'serviceorderapprovalmessage'
        };
        routes[MessageTypes.RxRefillRequestMessageGuid] = {
            route: 'rxrefillmessage',
            requiredFeature: 'Messages_RxRefill,Visits_RX'
        };
        routes[MessageTypes.PatientRxRefillRequestMessageGuid] = {
            route: 'rxrefillmessage',
            requiredFeature: 'Messages_RxRefill,Visits_RX'
        };
        routes[MessageTypes.PharmacyRefillRequestMessageGuid] = {
            route: 'pharmacyrefillmessage',
            requiredFeature: 'Messages_PharmacyRefill,Visits_RX'
        };
        routes[MessageTypes.RxRefillAndErxRequestMessageGuid] = {
            route: 'rxrefillmessagev2',
            requiredFeature: 'Messages_PharmacyRefill,Visits_RX,Messages_RxRefillRequestV2,Messages_RxChange'
        };

        function getTransitionForMessage(messageTypeId, messageId, messageSubTypeId, createNew, options) {
            var transition = {
                appRoute: 'message',
                opts: {
                    id: messageId
                }
            };
            
            if(options){
                _.merge(transition.opts, options);
            }

            var lowerMessageTypeId = messageTypeId.toLowerCase();
            var lowerMessageSubTypeId = messageSubTypeId.toLowerCase();

            var filteredRoutes = apFilterFeature(routes, 'requiredFeature');

            transition.appRoute = (createNew ? 'create' : '') +
                ((filteredRoutes[lowerMessageTypeId] && filteredRoutes[lowerMessageTypeId].route) ||
                (filteredRoutes[lowerMessageSubTypeId] && filteredRoutes[lowerMessageSubTypeId].route) ||
                'message');

            return transition;
        }

        return {
            getTransitionForMessage: getTransitionForMessage
        };
    }]);
